export default "__VITE_ASSET__BVHOSRip__"